var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-actions"},[_c('router-link',{attrs:{"to":_vm.route}},[_vm._v(_vm._s(_vm.$t('forgot.password')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }